<script>
const CountryListAPI = "https://ams4you.net/amsapi/public/websearch/GetAcaCountryList";
const CountryChangeAPI = "https://ams4you.net/amsapi/public/websearch/GetAcaCountryChange";
import axios from "axios";

export default {
    data() {
        return {
            query: "",
            SelCountry: {},
            SelLevel: [],
            Keyword: "",
            LevelLabel: "",
            CountryList: [],
            LevelList: [],
            LevelMenu: false,
        };
    },
    computed: {
        Setting() {
            return this.$parent.Setting;
        },
        Translation() {
            return this.$parent.Translation;
        },
        SetDataStep() {
            if (this.SelLevel?.length) {
                return 3;
            }
            if (this.SelCountry?.Id) {
                return 2;
            }
            return 1;
        },
        AcademicSelected() {
            if (!this.SelCountry?.Id) return false;
            if (!this.SelLevel?.length) return false;

            return true;
        },
    },
    watch: {
        SelCountry(val) {
            this.SelLevel = [];
            this.LevelList = [];
            if (val?.Id) {
                let LatestQuery = this.query + "&CountryId=" + val.Id;
                this.GetLevels(LatestQuery);
            }
        },
        SelLevel: {
            handler(val) {
                if (val.length) {
                    if (val?.length == 1) {
                        let first = val[0].Name;
                        first = val[0].Name?.length > 14 ? val[0].Name.slice(0, 14) + "..." : val[0].Name;
                        this.LevelLabel = first;
                    } else if (val?.length > 1 && val?.length < this.LevelList?.length) {
                        let first = val[0].Name;
                        first = val[0].Name?.length > 14 ? val[0].Name.slice(0, 14) + "..." : val[0].Name;
                        this.LevelLabel = first + `(+${val.length - 1} More)`;
                    } else if (val?.length == this.LevelList?.length) {
                        this.LevelLabel = "All Levels";
                    } else {
                        this.LevelLabel = "-";
                    }
                } else {
                    this.LevelLabel = "-";
                }
            },
            deep: true,
            immediate: true,
        },
    },
    methods: {
        MakeSearch() {
            let Path = "https://my.alternatifecs.com/search/academic";

            let SelLevelIds = this.SelLevel.map((el) => el.Id).join("-");
            let query = "?CountryId=" + this.SelCountry.Id + "&LevelId=" + SelLevelIds + "&Keyword=" + this.Keyword;
            window.open(Path + query, this.Setting.OpenInNewWindow ? "_blank" : "_self");
        },
        async GetCountries() {
            let ag = this.$parent.ag;
            let wid = this.$parent.wid;
            this.query = "?ag=" + ag + "&wfid=" + wid;
            const request = await axios.get(CountryListAPI + this.query);
            const response = request.data;
            this.CountryList = response.detail;
        },
        async GetLevels(query) {
            const request = await axios.get(CountryChangeAPI + query);
            const response = request.data;
            this.LevelList = response.detail;
        },
        ClearAll() {
            this.SelCountry = {};
            this.SelLevel = [];
            this.Keyword = "";
        },
    },
    mounted() {
        this.GetCountries();
    },
};
</script>
<template>
    <div
        class="card-type"
        :class="{
            active: AcademicSelected,
        }"
    >
        <div class="card-type-head">
            <div class="type-data">
                <h5 class="title">Akademik Eğitim</h5>
                <p class="desc">
                    Lorem, ipsum dolor sit amet consectetur adipisicing elit. Numquam perferendis quibusdam mollitia voluptatibus adipisci voluptas dolore fugiat commodi dignissimos vel!
                </p>
            </div>
        </div>
        <div class="card-type-content">
            <div class="input-group input-group-blur" :data-step="SetDataStep">
                <div class="input-row">
                    <div class="input-icon"></div>
                    <div class="input-content">
                        <label class="input-label">Ülke Seçiniz</label>
                        <v-select
                            class="form-control"
                            :options="CountryList"
                            label="Name"
                            :getOptionLabel="(option) => option.Name || '-'"
                            :clearable="false"
                            v-model="SelCountry"
                            :placeholder="Translation.SelectCountry"
                        />
                    </div>
                </div>
                <div class="input-row">
                    <div class="input-icon"></div>
                    <div class="input-content" id="HDropCnt" :class="{'pe-none': !SelCountry?.Id}">
                        <label class="input-label"> Eğitim Kademesi Seçiniz </label>
                        <div class="dropdown">
                            <button type="button" :class="{show: LevelMenu}" @click="LevelMenu = !LevelMenu" class="btn btn-dropdown text-white text-start" :disabled="!SelCountry?.Id" id="HDropBtn">
                                <span class="btn-dropdown-selected" id="HDropLbl" :class="{'pe-none': !SelCountry?.Id}">{{ LevelLabel }}</span>
                            </button>
                            <ul class="dropdown-menu dropdown-menu-animate dropdown-menu-list w-100" :class="{show: LevelMenu}" id="HDrop">
                                <button type="button" class="btn btn-dropdown-close" data-bs-toggle="dropdown" aria-expanded="false" @click="LevelMenu = !LevelMenu">
                                    <svg width="24" height="24" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="m4.21 4.387.083-.094a1 1 0 0 1 1.32-.083l.094.083L12 10.585l6.293-6.292a1 1 0 1 1 1.414 1.414L13.415 12l6.292 6.293a1 1 0 0 1 .083 1.32l-.083.094a1 1 0 0 1-1.32.083l-.094-.083L12 13.415l-6.293 6.292a1 1 0 0 1-1.414-1.414L10.585 12 4.293 5.707a1 1 0 0 1-.083-1.32l.083-.094-.083.094Z"
                                            fill="#333"
                                        />
                                    </svg>
                                </button>
                                <div class="dropdown-close-list">
                                    <li v-for="(item, index) in LevelList" :key="item.Id" class="filter-checkbox-list-item form-check">
                                        <input class="form-check-input" type="checkbox" :id="'lvl_' + item.Id" :value="{Name: item.Name, Id: item.Id}" v-model="SelLevel" />
                                        <label class="form-check-label" :for="'lvl_' + item.Id">{{ item.Name }} ({{ item.progCount }})</label>
                                    </li>
                                </div>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="input-row">
                    <div class="input-icon"></div>
                    <div class="input-content">
                        <label class="input-label">Program Adına Göre Ara</label>
                        <input id="searchboxText" type="text" class="form-control" placeholder="-" v-model="Keyword" />
                    </div>
                </div>
                <div class="form-progress"></div>
            </div>
            <div class="btn-grid">
                <button type="button" class="btn btn-link" @click="ClearAll" v-if="SetDataStep > 1">
                    <svg width="18" height="18" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M22.452 1.923a.75.75 0 0 1 0 1.06L16.14 9.296a6.814 6.814 0 0 0-1.067-1.053l6.32-6.32a.75.75 0 0 1 1.06 0ZM15.028 9.347a5.75 5.75 0 0 0-8.132 0l-.244.244 8.132 8.132.244-.244a5.75 5.75 0 0 0 0-8.132ZM1.884 12.966l3.613-2.409 8.32 8.321-2.408 3.613a.75.75 0 0 1-1.154.115L1.769 14.12a.75.75 0 0 1 .115-1.154Z"
                            fill="#fb4747"
                        ></path>
                    </svg>
                    Seçimi Temizle
                </button>
                <button type="button" class="btn btn-data" :disabled="!AcademicSelected" @click="MakeSearch">
                    <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="24" height="24" viewBox="0,0,256,256" style="fill: #000000">
                        <g
                            fill="#ffffff"
                            fill-rule="nonzero"
                            stroke="none"
                            stroke-width="1"
                            stroke-linecap="butt"
                            stroke-linejoin="miter"
                            stroke-miterlimit="10"
                            stroke-dasharray=""
                            stroke-dashoffset="0"
                            font-family="none"
                            font-weight="none"
                            font-size="none"
                            text-anchor="none"
                            style="mix-blend-mode: normal"
                        >
                            <g transform="scale(8.53333,8.53333)">
                                <path
                                    d="M13,3c-5.511,0 -10,4.489 -10,10c0,5.511 4.489,10 10,10c2.39651,0 4.59738,-0.85101 6.32227,-2.26367l5.9707,5.9707c0.25082,0.26124 0.62327,0.36648 0.97371,0.27512c0.35044,-0.09136 0.62411,-0.36503 0.71547,-0.71547c0.09136,-0.35044 -0.01388,-0.72289 -0.27512,-0.97371l-5.9707,-5.9707c1.41266,-1.72488 2.26367,-3.92576 2.26367,-6.32227c0,-5.511 -4.489,-10 -10,-10zM13,5c4.43012,0 8,3.56988 8,8c0,4.43012 -3.56988,8 -8,8c-4.43012,0 -8,-3.56988 -8,-8c0,-4.43012 3.56988,-8 8,-8z"
                                ></path>
                            </g>
                        </g>
                    </svg>
                    Sonuçları gör
                </button>
            </div>
        </div>
    </div>
</template>
